import type { ConditionFormValues } from "./ConditionFormValues"

type FieldName = keyof ConditionFormValues

const firstRegistrationDateName: FieldName = "firstRegistrationDate"
const mileageName: FieldName = "mileage"
const previousOwnersName: FieldName = "previousOwners"
const previousOwnerUsageHistoryName: FieldName = "previousOwnerUsageHistory"
const fullServiceHistoryName: FieldName = "fullServiceHistory"
const nonSmokerName: FieldName = "nonSmoker"
const formerRentalCarName: FieldName = "formerRentalCar"
const accidentFreeName: FieldName = "accidentFree"
const previousDamageName: FieldName = "previousDamage"
const reconditionedName: FieldName = "reconditioned"
const previousDamageAmountName: FieldName = "previousDamageAmount"
const previousDamageDescriptionName: FieldName = "previousDamageDescription"
const reconditioningAmountName: FieldName = "reconditioningAmount"
const reconditioningApproximateAmountName: FieldName = "reconditioningApproximateAmount"
const accidentDescriptionName: FieldName = "accidentDescription"

export const conditionFieldNames = {
	accidentDescriptionName,
	accidentFreeName,
	firstRegistrationDateName,
	formerRentalCarName,
	fullServiceHistoryName,
	mileageName,
	nonSmokerName,
	previousDamageAmountName,
	previousDamageDescriptionName,
	previousDamageName,
	previousOwnersName,
	previousOwnerUsageHistoryName,
	reconditionedName,
	reconditioningAmountName,
	reconditioningApproximateAmountName,
}
